import React from "react";
import UnitPricesPage from "./UnitPricesPage";

const OnePathUnitPrices = () => (
    <UnitPricesPage
        pageTitle="Unit Prices"
        reportName="OnePathUnitPrice"
        localFilePath={process.env.REACT_APP_OA_UNIT_PRICE_LOCAL_DATA}
    />
);

export default OnePathUnitPrices;